import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import "../../assets/stylesheets/review.css";
import Logo from "../../assets/image/logo.svg";
import axios from "axios";

function Review() {
  const { t, i18n } = useTranslation(["rev", "error"]);
  const [reviews, setReviews] = useState([]);

  const fetchReviews = async (lng) => {
    try {
      const res = await axios.get(
          `${process.env.REACT_APP_MY_API_KAY}/reviews?language=${lng}`
      );
      setReviews(
          res.data.map((item) => ({
            title: item.author,
            subTitle: item.content,
          }))
      );
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviews([]);
    }
  };

  useEffect(() => {
    fetchReviews(i18n.language);
  }, [i18n.language]);

  return (
      <>
        <Helmet>
          <link
              rel="canonical"
              href={`https://sievn.am/${i18n.language}/${t(
                  "rev"
              )}`}
          />
          <meta
              property="og:url"
              content={`https://sievn.am/${i18n.language}/${t(
                  "rev"
              )}`}
          />
          <meta property="og:title" content={t("reviewTitle")} />
          <meta property="og:site_name" content="sievn.am" />
          <meta property="og:description" content={t("reviewDescribe")} />
          <meta property="og:image" content={Logo} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta name="description" content={t("reviewDescribe")} />
          <title>{t("reviewTitle")}</title>
        </Helmet>

        <div className="review-page">
          <div className="main-container-review">
            <div className="headings-review">
              <h1>
                <em>{t("rTitle")}</em>
              </h1>
            </div>
            <div className="review-section-review">
              {reviews.length > 0 ? (
                  reviews.map((item, index) => (
                      <div className="review-card-review" key={index}>
                        <p className="title-review">{item.title}</p>
                        <div className="content-review">
                          <p>{item.subTitle}</p>
                        </div>
                        <div className="stars-review">⭐⭐⭐⭐⭐</div>
                      </div>
                  ))
              ) : (
                  <div className="fallback-review">
                    {t("noReviewsAvailable", { ns: "error" })}
                  </div>
              )}
            </div>
          </div>
        </div>
      </>
  );
}

export default Review;